import { render, staticRenderFns } from "./GlossQueue.vue?vue&type=template&id=2bc8bebc"
import script from "./GlossQueue.vue?vue&type=script&lang=js"
export * from "./GlossQueue.vue?vue&type=script&lang=js"
import style0 from "./GlossQueue.vue?vue&type=style&index=0&id=2bc8bebc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports